import styled from "styled-components";

const InsideUserPanelStyled = styled.div`

`;

export default InsideUserPanelStyled;